import React, { useEffect } from 'react';
import {
  SideNavItems,
  SideNavLink,
  SideNav,
} from '@carbon/react';


import {
  UserMultiple,
  InventoryManagement,
  Industry,
} from '@carbon/react/icons';

import { Overview, ChangePassword, Users, Contacts, Timetable } from './Pages';
import { Outlet, NavLink } from 'react-router-dom';

import "./_overrides.scss";
import { useSideNavContext } from '@/contexts/SideNavContextProvider';
import useUser from '@/lib/hooks/useUser';

export const account_child_routes = [
  {
    index: true,
    element: <Overview />,
  },
  {
    path: 'change_password',
    element: <ChangePassword />,
  },
  {
    path: 'contacts',
    element: <Contacts />,
  },
  {
    path: 'spots',
    element: <Timetable />,
  },
  {
    path: 'users',
    element: <Users />,
  },
];

const AccountPage = () => {
  return (
    <>
      <Outlet />
    </>
  );
};


export const AccountPageSideNav = () => {
  const {setVisibility, maximized} = useSideNavContext();

  const {isOwner, isAdmin} = useUser();
  useEffect(() => {
    setVisibility(true);
    return () => {
      setVisibility(false);
    }
  }, [setVisibility]);

  //console.info("Matches:", matches);

  return <SideNav
    expanded={maximized}
    isChildOfHeader={false}
    aria-label="Account Settings"
  >
    <SideNavItems>
      <SideNavLink
        renderIcon={InventoryManagement}
        as={NavLink}
        to="/me"
      >
        Übersicht
      </SideNavLink>
      { (isOwner || isAdmin) && <SideNavLink
        renderIcon={UserMultiple}
        as={NavLink}
        to="/me/users"
      >
        Benutzer
      </SideNavLink>
      }
      { (isOwner || isAdmin) && <SideNavLink
        renderIcon={UserMultiple}
        as={NavLink}
        to="/me/contacts"
      >
        Kontakte
      </SideNavLink>
      }
      <SideNavLink
        renderIcon={InventoryManagement}
        as={NavLink}
        to="/me/change_password"
      >
        Passwort ändern
      </SideNavLink>
      { (isOwner || isAdmin) && <SideNavLink
        renderIcon={Industry}
        as={NavLink}
        to="/me/spots">
        Spots Timetable
      </SideNavLink>
      }
    </SideNavItems>
  </SideNav>
}

export default AccountPage;
